<template>
  <div class="recipe-container">
    <b-row align-v="start">
      <b-col cols="12" lg="3" md="6" sm="6" xs="12" class="mb-3" v-for="recipe in recipes" v-bind:key="recipe.id" >
        <RecipeCard v-bind:recipe="recipe"></RecipeCard>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RecipeCard from './RecipeCard'

export default {
  name: 'recipes',
  components: {
    RecipeCard
  },
  props: {
    'recipes': Array
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipesList.vue